export default (reducerManagerId, reducer, initialState) =>
	(state = initialState, action) => {
		if (action && action.reducerManagerId === reducerManagerId) {
			return reducer(state, action);
		}
		return state;
	};
